<template>
    <a-card>
        <a-divider class="color-orange" orientation="left">购标供应商信息</a-divider>
        <a-table
                :columns="columns"
                :loading="tableLoading"
                :dataSource="packSignModel.BidPacksAttendList"
                :rowKey="record => record.id"
                :pagination="false">
            <span slot="order" slot-scope="record,text,index">{{index+1}}</span>
            <a slot="supplierName" slot-scope="text,record"
               @click="onView(record,packSignModel.isPay,packSignModel.qybzjxnzh)">{{text}}</a>
            <div slot="money" slot-scope="text,record">
                            <span v-if="packSignModel.isCgBsFy">
                                    <span><a-tag color="red">{{record.money}}</a-tag>元</span>
                            </span>
                <span v-else>
                                无需缴纳
                            </span>
            </div>
            <div slot="mergeAccno" slot-scope="text,record">
                            <span v-if="packSignModel.isPay==='1'">
                                <div v-if="packSignModel.qybzjxnzh === '1'">
                                <div v-if="record.mergeAccno">
                                    <span>{{record.mergeAccno}}</span>
                                </div>
                                <div v-else>
                                    无农行帐号
                                </div>
                                    </div>
                                <div v-else>
                                    不使用农行帐号
                                </div>
                            </span>
                <span v-if="packSignModel.isPay==='0'">
                                无需缴纳</span>
            </div>
            <span slot="contacts" slot-scope="text,record">{{text}}({{record.mobile}})</span>
            <span slot="regDate" slot-scope="text,record">{{text|formatTime}}</span>
            <span slot="action" slot-scope="text, record">
                 <a class="ml-1 mr-1" type="primary"
                    @click="onEdit(record)">编辑</a>
                  <a-divider type="vertical"/>
                <a class="ml-1 mr-1" type="primary" v-show="packSignModel.isCgBsFy"
                          @click="onDel(record)">移除</a>
                 <a class="ml-1 mr-1"  v-show="!packSignModel.isCgBsFy"
                           @click="onZjDel(record)">移除</a>
                   <a-divider type="vertical"/>
                <span v-if="packSignModel.isCgBsFy">
                  <invoice-pop-confirm
                      :item="{
                    ...record,
                    attendId:record.id,
                  id:record.orderId,
                  projectName:packSignModel.xmmc,
                  projectCode:packSignModel.xmbh}" @refresh="$emit('success')"/>
<!--                      <a-popconfirm placement="top" :ok-text="record.kpzt === '1'?'确认未开票':'确认开票'" cancel-text="取消"-->
<!--                                    @confirm="onEditKp(record)">-->
<!--                        <a-icon slot="icon" type="question-circle-o" style="color: red"/>-->
<!--                        <template slot="title">-->
<!--                      <p>供应商名称：{{record.supplierName}}</p>-->
<!--                      <p>信用代码（税号）：{{record.supplierCode}}</p>-->
<!--                      <p>项目名称：{{packSignModel.xmmc}}</p>-->
<!--                      <p>项目编号：{{packSignModel.xmbh}}</p>-->
<!--                    </template>-->
<!--                    <a class="ml-1 mr-1" :style="record.kpzt === '1'?'color: red':''"-->
<!--                    >{{record.kpzt === '0'?'未开票':'已开票'}}</a>-->
<!--                  </a-popconfirm>-->
                </span>
                 <span v-else>无需开票</span>
            <span v-if="packSignModel.isPay==='1' && packSignModel.qybzjxnzh === '1' ">
                <a-divider type="vertical"/>
           <a :loading="btnLoading" class="ml-1 mr-1" v-if="!record.bankAccount" type="primary"
              @click="applyAccount(record)">生成农行帐号</a>
                  </span>
                </span>

        </a-table>
        <div class="mt-5 text-center">
        </div>
        <div>
            <a-modal v-model="visibleDel"  title="标书费退费" @ok="onShowOpenModalOk"  style="text-align: center">
                <a-radio-group v-model="isReg" style="text-align: left">
                    <a-radio value="1">需要进行退还标书费处理  （系统会生成退费请求给财务）</a-radio>
                    <a-radio value="0">无需退还标书费</a-radio>
                </a-radio-group>
            </a-modal>
        </div>
        <attend-info ref="AttendInfo1" :system_type="systemType" :visible="showAttendInfoModal1" :order-id="orderId"
                     @cancel="showAttendInfoModal1 = false"
                     @success="OnAttendInfoModal1"></attend-info>
        <attend-supper-edit ref="attendSupperEdit" :visible="showAttendSupperEditModal"
                            @cancel="showAttendSupperEditModal = false"
                            @success="OnAttendSupperEditModal"
        />
        <per-del-supplier ref="perDelSupplier" :visible="showPerDelSupplierModal"
                          @cancel="showPerDelSupplierModal = false" :systemType="systemType"
                          @success="OnPerDelSupplierModal"
        />
    </a-card>
</template>
<script>
  import { PageView } from '@/layouts'
  import qs from 'qs'
  import moment from 'moment'
  import attendInfo from '../../project/bidattend/attendInfo'
  import AttendSupperEdit from '../../project/bidattend/AttendSupperEdit'
  import PerDelSupplier from '../../project/bidattend/PerDelSupplier'
  import InvoicePopConfirm from '@/views/bid/cwgl/InvoicePopConfirm'

  export default {
    name: 'ApplyView',
    props: ['packId', 'projectId', 'systemType'],
    components: {
      InvoicePopConfirm,
      PageView,
      attendInfo,
      AttendSupperEdit,
      PerDelSupplier
    },
    filters: {
      formatTime (val) {
        if (val) {
          let text = ''
          text = val.substring(0, 16)
          return text
        }
      },
    },
    data () {
      return {
        orderId: '',
        tableLoading: false,
        isReg:'',
        visibleDel:false,
        btnLoading: false,
        showAttendInfoModal1: false,
        showPerDelSupplierModal: false,
        showAttendSupperEditModal: false,
        columns: [
          {
            title: '序号',
            width: '8%',
            scopedSlots: { customRender: 'order' }
          },
          {
            title: '供应商名称',
            width: '25%',
            ellipsis: true,
            dataIndex: 'supplierName',
            scopedSlots: { customRender: 'supplierName' }
          },
          {
            title: '联系人',
            width: '15%',
            dataIndex: 'contacts',
            scopedSlots: { customRender: 'contacts' }
          },
          {
            title: '购标时间',
            width: '12%',
            dataIndex: 'regDate',
            scopedSlots: { customRender: 'regDate' }
          },
          {
            title: '标书费金额',
            width: '8%',
            dataIndex: 'money',
            scopedSlots: { customRender: 'money' }
          },
          {
            title: '农行保证金帐号',
            width: '12%',
            scopedSlots: { customRender: 'mergeAccno' }
          },
          {
            title: '操作',
            width: '22%',
            scopedSlots: { customRender: 'action' }
          }

        ],
        size: 'default',
        packSignModel: []
      }
    },
    created () {
      this.packSignData()
      console.log(this.systemType)
    },
    methods: {
      OnAttendSupperEditModal () {
        this.showAttendSupperEditModal = false
        this.packSignData()
      },
      onEdit (record) {
        this.showAttendSupperEditModal = true
        this.$refs.attendSupperEdit.getSupperEditData(record.id)
      },
      onEditKp (record) {
        let that = this
        const data = {
          attendOrderId: record.orderId,
          kpzt: record.kpzt === '0' ? '1' : '0'
        }
        that.$http.post('/api/1/signSupplier/setAttendKp.json', qs.stringify(data)).then(function (response) {
          if (response.code !== 200) {
            that.$message.error('开票失败')
            return
          }
          // that.packSignData()
          that.$emit('success')
        })
      },
      applyAccount (record) {
        let that = this
        that.tableLoading = true
        record.type = that.systemType
        that.$http.post('/api/1/signSupplier/applyAccount.json', qs.stringify(record)).then(function (response) {
          // that.btnLoading = false
          if (response.code === 200) {
            // that.refreshBondAll()
            const result = response.result
            that.refreshData(record, result, '1')
            that.$message.success('生成成功')
          }
          that.tableLoading = false
        })
      },
      refreshData (record, result, type) {
        let that = this
        let packSignModel = that.packSignModel
        let BidPacksAttendList = []
        let newData = []
        if (packSignModel) {
          BidPacksAttendList = packSignModel.BidPacksAttendList
          if (BidPacksAttendList.length > 0) {
            for (let j = 0; j < BidPacksAttendList.length; j++) {
              newData = [...BidPacksAttendList]
              const target = newData.filter(item => record.id === item.id)[0]
              if (target) {
                console.log(target)
                if ('1' === type) {
                  target['accountBookNo'] = result.accountBookNo
                  target['bankAccount'] = result.account
                  target['bondId'] = result.bondId
                  target['state'] = '0'
                  target['mergeAccno'] = result.mergeAccno
                } else if ('2' === type) {
                  target['bondMoney'] = 100
                  target['state'] = result.state
                }
                break
              }
            }
          }
        }
      },
      refreshBondAll () {
        let that = this
        that.packData('1')
      },
      refreshBond (record, deposit) {
        let that = this
        that.tableLoading = true
        that.$http.get('/api/1/signSupplier/getCurrentBond.json?deposit=' + deposit + '&bondId=' + record.bondId + '&bankAccount=' + record.bankAccount + '&accountBookNo=' + record.accountBookNo).then(function (response) {
          that.tableLoading = false
          if (response.code === 200) {
            const result = response.result
            that.refreshData(record, result, '2')
            that.$message.success('刷新成功')
            // let newData = []
            // let packAttends = []
            // if (response.code === 200) {
            //   const result = response.result
            //   let packModel = that.packModel
            //   if (packModel.length > 0) {
            //     const target1 = packModel.filter(item => record.packId === item.id)[0]
            //     if (target1)
            //     {
            //       target1['bondPayNum'] = result.bondPayNum
            //     }
            //     for (let i = 0; i < packModel.length; i++) {
            //       packAttends = packModel[i].PackAttends
            //       if (packAttends.length > 0) {
            //         for (let j = 0; j < packAttends.length; j++) {
            //           newData = [...packAttends]
            //           const target = newData.filter(item => record.id === item.id)[0]
            //           if (target) {
            //             target['bondMoney'] = result.bal
            //             target['state'] = result.state
            //           }
            //         }
            //       }
            //     }
            // that.packModel = newData
          }
        })
      },
      OnAttendInfoModal1 (val) {
        this.showAttendInfoModal1 = false
        if ('1' === val) {
          this.packSignData()
        }

      },
      onView (record, isPay, qybzjxnzh) {
        this.showAttendInfoModal1 = true
        console.log(record)
        this.orderId = record.orderId
        this.$refs.AttendInfo1.packSupplier(record.id, isPay, qybzjxnzh)
      },
      onChange (e) {
        console.log('size checked', e.target.value)
        this.size = e.target.value
      },
      // 获取包组数据
      packData (val) {
        const that = this
        if ('1' === val) {
          that.tableLoading = true
        }
        that.$http.get('/api/1/signSupplier/getBidPacksSignList.json?projectId=' + that.projectId + '&type=' + that.systemType).then(function (response) {
          that.spinning = false
          if ('1' === val) {
            that.tableLoading = false
          }
          if (response.code === 200) {
            const result = response.result
            that.packModel = result
          }
        })
      },

      OnPerDelSupplierModal (xmjn) {
        this.showPerDelSupplierModal = false
        if ("1" === xmjn ){
          this.$emit("success","all")
        }else {
          this.packSignData()
        }
      },
      onShowOpenModalOk(){
        const that = this
        if (that.isReg){
          if ("1" === that.packSignModel.xmjn)
          {
            this.doDel2()

          }else {
            this.doDel1()
          }
          that.isReg=''
          that.visibleDel = false
        }else {
          that.$message.warning("请先选择是否需退标书费！")
        }
      },
      doDel1(){
        const that = this
        const record = that.record
        that.visibleDel = false
        that.$http.get('/api/1/signSupplier/checkIsDelAttend.json?bzid=' + that.packId + '&type=' + that.systemType + '&attendId=' + record.id+'&isReg='+that.isReg).then(function (response) {
          if (200 !== response.code) {
            return
          }
          if (response.result.isOpen) {
            that.showPerDelSupplierModal = true
            that.$refs.perDelSupplier.onLoad(record, response.result.delTarget, response.result.BondId,response.result.isCanDel)
          } else {
            that.onConfirm(record, response.result.message, response.result.isDel, response.result.delTarget, response.result.BondId, response.result.isCanDel)
          }
        })
      },
      doDel2(){
        const that = this
        const record = that.record
        that.$http.get('/api/1/signSupplier/checkIsDelAttendByProject.json?xmid=' + that.projectId + '&type=' + that.systemType +'&isReg='+that.isReg+ '&attendId=' + record.id+'&supplierCode='+record.supplierCode).then(function (response) {
          if (200 !== response.code) {
            return
          }
          if (response.result.isOpen) {
            that.showPerDelSupplierModal = true
            that.$refs.perDelSupplier.onLoad(record,'','','',that.packSignModel.xmjn)
          } else {
            that.onConfirm1(record, response.result.message, response.result.isDel)
          }
        })

      },
      onZjDel(record){
        const that = this
        that.record =record
        if ("1" === that.packSignModel.xmjn)
        {
          that.$confirm({
            title: '请确认',
            content: '本项目为按项目整体购标的项目，本操作会将供应商在所有包组的报名记录都删除，是否确认？',
            onOk: () => {
              that.isReg = '0'
              this.doDel2()
              console.log('您点击了确定！')
            },
            onCancel: () => {
              console.log('您点击了取消！')
            }
          })
        }else {
          that.isReg = '0'
          this.doDel1()
        }
      },
      onDel (record) {
        const that = this
        that.record =record
        console.log(that.packSignModel.xmjn)
        if ("1" === that.packSignModel.xmjn)
        {
          that.$confirm({
            title: '请确认',
            content: '本项目为按项目整体购标的项目，本操作会将供应商在所有包组的报名记录都删除，是否确认？',
            onOk: () => {
              that.visibleDel = true
              console.log('您点击了确定！')
            },
            onCancel: () => {
              console.log('您点击了取消！')
            }
          })
        }else {
          that.visibleDel = true
        }
      },

      onConfirm1 (record, conten, isDel) {
        let that = this
        that.$confirm({
          title: '请确认',
          content: conten,
          onOk: () => {
            if (!isDel){
              return
            }
            that.$http.get('/api/1/signSupplier/delAttendSupByProject.json?xmid=' + that.projectId + '&supplierCode=' + record.supplierCode ).then(function (response) {
              if (200 !== response.code) {
                that.$message.error('删除失败')
                return
              }
              that.$message.success('删除成功')
              that.OnPerDelSupplierModal(that.packSignModel.xmjn)
            })
            console.log('您点击了确定！')
          },
          onCancel: () => {
            console.log('您点击了取消！')
          }
        })
      },

      onConfirm (record, conten, isDel, delTarget, BondId, isCanDel) {
        let that = this
        isCanDel = !!isCanDel
        that.$confirm({
          title: '请确认',
          content: conten,
          onOk: () => {
            if (isDel) {
              that.$http.get('/api/1/signSupplier/delAttendSup.json?id=' + record.id + '&isDel=' + isDel + '&delTarget=' + delTarget + '&BondId=' + BondId+'&isCanDel='+isCanDel).then(function (response) {
                if (200 !== response.code) {
                  that.$message.error('删除失败')
                  return
                }
                that.$message.success('删除成功')
                that.packSignData()
              })
            }
            console.log('您点击了确定！')
          },
          onCancel: () => {
            console.log('您点击了取消！')
          }
        })
      },


      // 获取包组购标数据
      packSignData (val) {
        const that = this
        that.tableLoading = true
        that.$http.get('/api/1/signSupplier/getBidPacksSignCWListByPackId.json?projectId=' + that.projectId + '&packId=' + that.packId + '&type=' + that.systemType).then(function (response) {
          that.tableLoading = false
          if (response.code === 200) {
            const result = response.result
            that.packSignModel = result
            console.log(result)
          }
        })
      },

    }
  }
</script>

<style scoped>
</style>
